"use strict";
exports.__esModule = true;
exports.INCOME_COLLECTION_MODAL_CONTENT = void 0;
exports.INCOME_COLLECTION_MODAL_CONTENT = {
    TITLE: 'What counts as income?',
    TOP_BODY: 'Your annual gross income includes what you earn from:',
    BULLETS: [
        'Employment',
        'Investments',
        'Retirement',
        'Social security benefits',
        'Public assistance',
        'Any money deposited directly into your account (individual or joint)',
        'If you are 21 or over, you may also include the amount of someone else’s income that is regularly used to pay your expenses',
    ],
    FOOTER_BODY: 'Alimony, child support, or separate maintenance income shouldn’t be included unless relied upon for credit. ',
    CTA: 'Close'
};
